// GaeSliceSchema.ts

import { ApiGaeSessionResSchema } from "@bridge-applications/eh-types";
import { z } from "zod";

export const GaeSliceSchema = z.object({
    isSkeletonRendering: z.boolean(),
    data: ApiGaeSessionResSchema.nullable(),
});
